<div class="bar-graph"></div>